import Link from "@/components/AppLink";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";

const GetStarted = () => {
  return (
    <section className="get-started-section index11">
      <div className="overlay pt-120 pb-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="section-header text-center">
                <h2 className="title">
                  Same OracleMarket account—now pocket-sized.
                </h2>
                <p>
                  Biometric unlock, instant document capture for KYC updates,
                  and Apple Pay / Google Pay ready checkout links help you close
                  deals before you get back to your desk.
                </p>
                <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
                  Get the mobile app
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
